function reducer(state = [], action) {

    switch (action.type) {
      case 'VALIDATIONS/SUMMARY/SET':
        return action.validations_summary;
      case 'VALIDATIONS/SUMMARY/SET/CLEAR':
        return null;
      default:
        return state;
    }
  }
  
  export default reducer;